import {difference, keys, find, map, omit, filter, keyBy} from 'helpers';

export function sortingInfo(state = {}, action) {
  switch (action.type) {
    case 'SORTING_UPDATE':
      const { modelId = '0', name, objectType = '', ids, generateId } = action;
      const existent = find(state, { modelId, name, type: objectType });
      return {
        ...state,
        [existent ? existent.serverId : generateId()]: {
          serverId: generateId(),
          ...existent,
          ids,
          modelId,
          name,
          type: objectType,
        }
      }

    case 'UI_SETTING':
      if (action.module == 'goalPlan' && action.value != 'customOrder') {
        const remove = filter(state, ({ type, modelId }) => modelId == action.id && /activity|milestone/.test(type));
        return omit(state, map(remove, 'serverId'));
      }
      return state;

    case 'SERVER_DATA_RECEIVED':
      const removed = difference(keys(state), action.existingElementIds.sortingInfo);
      if (action.sortingInfo.length || removed.length) {
        return omit({
          ...state,
          ...keyBy(action.sortingInfo, 'serverId'),
        }, removed);
      }
      return state;

    case 'TESTING_DELETE_ALL':
      return {};

    default:
      return state;
  }
}
